__turbopack_context__.v({
  "thingstodoActions": "ThingsToDoHeader-module__vV8vaW__thingstodoActions",
  "thingstodoHeaderTop": "ThingsToDoHeader-module__vV8vaW__thingstodoHeaderTop",
  "thingstodoIconBtn": "ThingsToDoHeader-module__vV8vaW__thingstodoIconBtn",
  "thingstodoTitle": "ThingsToDoHeader-module__vV8vaW__thingstodoTitle",
  "thingtodoheroimage": "ThingsToDoHeader-module__vV8vaW__thingtodoheroimage",
  "thingtodoheroimageWrapper": "ThingsToDoHeader-module__vV8vaW__thingtodoheroimageWrapper",
});
